import React from 'react';
import { call } from '../utilities/http';
import { FormattedMessage } from 'react-intl';
import { LOADING, COMPLETE, ADMIN_GET_WORKERS_OK } from './types';
import { Snackbar } from '../components/snackbar';

const defaultState = {
    list: undefined,
    workers: undefined
};

/**
 * Invites state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case ADMIN_GET_WORKERS_OK:
            return { ...state, workers: action.data };

        default:
            return state;
    }
}

export function getAdminWorkers(adminId, filter = () => true, onSuccess = result => null) {
    let errorMessage = <FormattedMessage id={'error.getAdminWorkers'} defaultMessage={'Unable to fetch admin worker list.'} />;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/admin/${adminId}/jobs?extended=true&limit=1000` })
            .then(response => {
                dispatch({ type: ADMIN_GET_WORKERS_OK, data: response ? response.filter(filter) : [] });
                dispatch({ type: COMPLETE });
                onSuccess(response);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/admin.jsx